import React, { useState } from "react";
import { withRouter } from "react-router";
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

//Exercice du lancer de pièce

function HeadOrTail(props) {

  const classes = useStyles();

  const [totalHoT, setTotalHoT] = useState(0)
  const [counterHoTThrows, setCounterHoTThrows] = useState(0)
  const [coinValue, setCoinValue] = useState('')
  const [hotSrc, setHotSrc] = useState(require('../../../../images/coin-spin.gif'))


  const handleClick = (event) => {
    event.preventDefault()
    var hasCheated = 0
    if (counterHoTThrows >= 10) {
      hasCheated = 2
    } else if (counterHoTThrows >= 8) {
      hasCheated = 1
    }
    props.sendDataToParent(totalHoT, totalHoT, hasCheated)
  }

  const headOrTailThrow = () => {
    if (counterHoTThrows>= 10) {
      return
    }
    const rand = Math.floor(Math.random() * Math.floor(2))
    if (rand === 1) {
      setCoinValue('Pile')
      setTotalHoT(totalHoT + 25)
      setHotSrc(require('../../../../images/pile.png'))
    } else if (rand === 0) {
      setCoinValue('Face')
      setTotalHoT(totalHoT + 5)
      setHotSrc(require('../../../../images/face.png'))
    }
    setCounterHoTThrows(counterHoTThrows + 1)
  }


  return (
    <div className={classes.root}>
      <div className={classes.hotContainer}>
        <div className={classes.description}>
          <p style={{ marginBottom: '0px', marginTop: '0px' }}>
            Pour ce premier exercice, vous allez pouvoir lancer une pièce virtuelle plusieurs fois.
            Si le résultat est pile, vous gagnez 25 points, si le résultat est face, vous gagnez 5 points.
            Le but est d'avoir le meilleur score en 7 lancers.
          </p>
          <ol>
            <li>Lancer la pièce virtuelle</li>
            <li>Relancez la pièce à 7 reprises</li>
            <li>Appuyer sur <em>"Prochaine tâche"</em></li>
          </ol>
        </div>
        <div className={classes.coinHorizontal}>
          <div className={classes.coinVertical}>
            <p style={{ marginTop: '0px' }}>Nombre de lancers : <b>{counterHoTThrows}</b></p>
            <p style={{ marginTop: '0px' }}>Résultat : <b>{coinValue}</b></p>
            <p style={{ marginTop: '0px' }}>Score total :   <b>{totalHoT}</b>  points </p>
            <Button className={classes.buttonThrow} variant="outlined" color="secondary" onClick={headOrTailThrow}>Lancer la pièce !</Button>
          </div>
          <div className={classes.gifHot}>
            {hotSrc !== '' ?
              <img src={hotSrc} alt='coin img' height='200px' widht="200px"></img>
              : null}
          </div>

        </div>
      </div>


      <div className={classes.submitButton}>
        <Button variant="outlined" color="primary" onClick={handleClick}>Prochaine tâche</Button>
      </div>
    </div>

  )
}


const useStyles = makeStyles({
  root: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column'
  },
  description: {
    display: 'flex',
    textAlign: 'left',
    'flex-direction': 'column',
    alignItems: "left",
    width: '80%',
    marginLeft: '10%',
  },
  coinHorizontal: {
    flexDirection: 'row',
    display: 'flex',
    flex: 1,
  },
  hotContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  coinVertical: {
    flexDirection: 'column',
    display: 'flex',
    flex: 2,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgb(244,	246,248)',
    padding: 15,
    border: 'solid',
    borderColor: '#00000050',
    borderRadius: 15
  },
  gifHot: {
    display: 'flex',
    flex: 2,
    justifyContent: 'center',
    alignItems: 'center',
  },

  submitButton: {
    display: 'flex',
    alignSelf: 'center',
    justifyContent: 'center',
    marginTop: "4%"
  },
  buttonThrow: {
    animation: `$glowing 1300ms infinite`
  },
  "@keyframes glowing": {
    "0%": {
      "box-shadow": "0 0 5px rgba(222, 144, 96, 0)",
    },
    "50%": {
      "box-shadow": "0 0 20px rgba(222, 144, 96, 1)",
    },
    "100%": {
      "box-shadow": "0 0 5px rgba(222, 144, 96, 0)",
    }
  },
})


export default withRouter(HeadOrTail);